import React from "react"
import { Box, Button, Grid, TextField, useTheme } from "@mui/material"
import Header from "components/Header"
import { useLocation } from "react-router-dom"
import axios from "axios"
import encrypt from "lib/encryption"
import { config } from "config"
import utill from "lib/utill"
import store from "state/store"
 

const UserDelete = () => {
  const theme = useTheme()
  const routeLocation = useLocation()
  const initialName = routeLocation.state?.name ?? ""

  

  const handleNameChange = (event) => {
    setName(event.target.value)
  }

  const handlePhoneChange = (event) => {
    setPhone(event.target.value)
  }

  const [name, setName] = React.useState("")
  const [phone, setPhone] = React.useState("")
  const [isLoading, setIsLoading] = React.useState(false)
  const [kiosks, setKiosks] = React.useState([])
  const kioskResultRef = React.useRef(null)

  const handleSave = (e) => {
    e.preventDefault()
    const n = (name || "").trim()
    const p = (phone || "").trim()
    if (!n) {
      window.alert("이름을 입력해 주세요.")
      return
    }
    if (!p) {
      window.alert("휴대폰 번호를 입력해 주세요.")
      return
    }
    const resultObj = kioskResultRef.current
    if (resultObj && typeof resultObj === "object") {
      const items = Array.isArray(resultObj.Item)
        ? resultObj.Item
        : Array.isArray(resultObj.items)
        ? resultObj.items
        : Array.isArray(resultObj.item)
        ? resultObj.item
        : []
      for (let i = 0; i < items.length; i += 1) {
        const item = items[i] || {}
        const hostLocationOid = item.host_location_oid
        updateForce_approveFacial(p, hostLocationOid)
      }
      updateForce_BeaconRefresh(p)
      alert("삭제 되었습니다.")
    } else {
      console.log("kioskResultRef.current is empty")
    }
  }

  let authKeyEncD = ""
  try {
    if (process.env.REACT_APP_AUTH_KEY && process.env.REACT_APP_PUBLIC_KEY) {
      authKeyEncD = encrypt(
        process.env.REACT_APP_AUTH_KEY,
        process.env.REACT_APP_PUBLIC_KEY
      )
    }
  } catch (e) {
    console.error("AuthKey 암호화 오류:", e)
  }

  // 지점(키오스크) 리스트 조회 - 첫 진입 시 1회 호출
  React.useEffect(() => {
    getHostKioskList()
  }, [])

  const getHostKioskList = async () => {
    const url = `${config.api || ""}/webservices/GeneralService.asmx`
    const bodyJson = {
      request: {
        page_no: 1,
        name: "",
        host_oid: utill.base64Decode(sessionStorage.getItem("x-a-h-o") ?? ""),
      },
    }
    const body = {
      AuthKeyEncD: authKeyEncD,
      SessionIDEncN: store.getState().session,
      AdminOid: utill.base64Decode(sessionStorage.getItem("x-a-d-a") ?? ""),
      InputJSON: JSON.stringify(bodyJson),
      Mode: "GET_HOST_KIOSK_LIST",
    }
    const headers = {
      "Content-Type": "text/xml;charset=UTF-8",
      soapAction: "http://tempuri.org/GetAdminDataJSON",
    }
    const requestBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <GetAdminDataJSON xmlns="http://tempuri.org/">
            <AuthKeyEncD>${body.AuthKeyEncD}</AuthKeyEncD>
            <SessionIDEncN>${body.SessionIDEncN}</SessionIDEncN>
            <AdminOid>${body.AdminOid}</AdminOid>
            <InputJSON>${body.InputJSON}</InputJSON>
            <Mode>${body.Mode}</Mode>
          </GetAdminDataJSON>
        </soap:Body>
      </soap:Envelope>`

    try {
      setIsLoading(true)
      const response = await axios.post(url, requestBody, {
        headers,
      })

      setIsLoading(false)
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(response.data, "text/xml")

      const resultNode = xmlDoc.getElementsByTagName("Result")[0]
      const resultText = resultNode?.textContent ?? "{}"
      const resultObject = JSON.parse(resultText)

      if (resultObject.Result != null) {
        const result = resultObject.Result
        if (result === "+OK") {
          kioskResultRef.current = resultObject
          setKiosks(resultObject.Item || [])
        } else {
          console.log("GET_HOST_KIOSK_LIST 처리 에러", resultObject)
        }
      } else {
        console.log("GET_HOST_KIOSK_LIST 응답 포맷 에러")
      }
    } catch (error) {
      setIsLoading(false)
      console.error(error)
    }
  }

  const updateForce_approveFacial = async (phonenum, hostLocationOid) => {
    const url = `${config.api}/webservices/GeneralService.asmx`
    const bodyJson = {
      request: {
        phone_num: phonenum,
        host_location_oid: hostLocationOid,
      },
    }
    const body = {
      AuthKeyEncD: authKeyEncD,
      SessionIDEncN: store.getState().session,
      AdminOid: utill.base64Decode(sessionStorage.getItem("x-a-d-a") ?? ""),
      InputJSON: JSON.stringify(bodyJson),
      Mode: "FORCE_DELETE_USER_FACIAL_ADMIN",
    }
    const headers = {
      "Content-Type": "text/xml;charset=UTF-8",
      soapAction: "http://tempuri.org/UpdateAdminDataJSON",
    }

    const requestBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <UpdateAdminDataJSON xmlns="http://tempuri.org/">
            <AuthKeyEncD>${body.AuthKeyEncD}</AuthKeyEncD>
            <SessionIDEncN>${body.SessionIDEncN}</SessionIDEncN>
            <AdminOid>${body.AdminOid}</AdminOid>
            <InputJSON>${body.InputJSON}</InputJSON>
            <Mode>${body.Mode}</Mode>
          </UpdateAdminDataJSON>
        </soap:Body>
      </soap:Envelope>`

    try {
      setIsLoading(true)
      const response = await axios.post(url, requestBody, {
        headers,
      })
      console.log("response.data (FORCE_APPROVE_USER_FACIAL_ADMIN):", response?.data)
      
      setIsLoading(false)
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(response.data, "text/xml")

      const resultNode = xmlDoc.getElementsByTagName("Result")[0]
      const resultText = resultNode?.textContent ?? "{}"
      let resultObject
      try {
        resultObject = JSON.parse(resultText)
      } catch (e) {
        console.error("Invalid JSON in <Result>:", resultText, e)
        alert("서버 응답 형식 오류입니다.")
        return
      }

      if (resultObject.Result != null) {
        const result = resultObject.Result
        const resultCode = resultObject.ResultCode
        if (result === "+OK") {
          if (resultCode === "-INVALID_USER") {
            alert("존재하지 않는 유저 입니다.")
          } else if (resultCode === "-INVALID_HOST") {
            alert("잘못된 접근 입니다.")
          } else if (resultCode === "-EXIST_USER") {
            alert("이미 등록된 유저 입니다.")
          } else {
            // alert("삭제 되었습니다.")
          }
        }
      } else {
        console.log("resultObject:", resultObject.ResultCode)
        alert("저장 실패했습니다. 서버 오류입니다.")
      }
    } catch (error) {
      setIsLoading(false)
      if (error && error.response) {
        console.error("axios error response.data (FORCE_APPROVE_USER_FACIAL_ADMIN):", error.response.data)
      }
      console.error(error)
    }
  }

  const updateForce_BeaconRefresh = async (phonenum) => {
    const url = `${config.api}/webservices/GeneralService.asmx`
    const bodyJson = {
      request: {
        phone_num: phonenum,
      },
    }
    
    const body = {
      AuthKeyEncD: authKeyEncD,
      SessionIDEncN: store.getState().session,
      AdminOid: utill.base64Decode(sessionStorage.getItem("x-a-d-a") ?? ""),
      InputJSON: JSON.stringify(bodyJson),
      Mode: "FORCE_UPDATE_USER_STATUS",
    }
    const headers = {
      "Content-Type": "text/xml;charset=UTF-8",
      soapAction: "http://tempuri.org/UpdateAdminDataJSON",
    }

    const requestBody = `<?xml version="1.0" encoding="utf-8"?>
      <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
        <soap:Body>
          <UpdateAdminDataJSON xmlns="http://tempuri.org/">
            <AuthKeyEncD>${body.AuthKeyEncD}</AuthKeyEncD>
            <SessionIDEncN>${body.SessionIDEncN}</SessionIDEncN>
            <AdminOid>${body.AdminOid}</AdminOid>
            <InputJSON>${body.InputJSON}</InputJSON>
            <Mode>${body.Mode}</Mode>
          </UpdateAdminDataJSON>
        </soap:Body>
      </soap:Envelope>`

    try {
      setIsLoading(true)
      const response = await axios.post(url, requestBody, {
        headers,
      })

      console.log("response.data (FORCE_UPDATE_USER_STATUS):", response?.data)
      
      setIsLoading(false)
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(response.data, "text/xml")

      const resultNode = xmlDoc.getElementsByTagName("Result")[0]
      const resultText = resultNode?.textContent ?? "{}"
      let resultObject
      try {
        resultObject = JSON.parse(resultText)
      } catch (e) {
        console.error("Invalid JSON in <Result>:", resultText, e)
        console.log("서버 응답 형식 오류입니다.")
        return
      }

      if (resultObject.Result != null) {
        const result = resultObject.Result
        const resultCode = resultObject.ResultCode
        if (result === "+OK") {
          console.log("푸쉬 전송성공")
        }
      } else {
        console.log("resultObject:", resultObject.ResultCode)
        console.log("푸쉬 실패했습니다. 서버 오류입니다.")
      }
    } catch (error) {
      setIsLoading(false)
      if (error && error.response) {
        console.error("axios error response.data (FORCE_APPROVE_USER_FACIAL_ADMIN):", error.response.data)
      }
      console.error(error)
    }
  }

  

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="사용자 삭제" subtitle="등록되어있는 모든 기계에서 사용자를 삭제합니다." />
      <Box component="form" onSubmit={handleSave} mt={2}>
        <Grid container spacing={2}>
          <Grid item xs={5} md={2}>
            <TextField
              fullWidth
              label="삭제할 이름"
              value={name}
              onChange={handleNameChange} sx={{
                mr: 1,
                "& .MuiInputBase-root.Mui-focused": {
                  backgroundColor: theme.palette.grey[100], // 포커스 시 배경 색상
                  color: theme.palette.secondary[50], // 포커스 시 텍스트 색상
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: theme.palette.text.secondary, // 포커스 시 라벨 색상
                },
              }}
            />
          </Grid>
          <Grid item xs={5} md={2}>
            <TextField
              fullWidth
              label="삭제할 휴대폰"
              value={phone}
              onChange={handlePhoneChange}sx={{
                mr: 1,
                "& .MuiInputBase-root.Mui-focused": {
                  backgroundColor: theme.palette.grey[100], // 포커스 시 배경 색상
                  color: theme.palette.secondary[50], // 포커스 시 텍스트 색상
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: theme.palette.text.secondary, // 포커스 시 라벨 색상
                },
              }}
            />
          </Grid>
        </Grid>
        <Box display="flex" gap={2} mt={3}>
          <Button type="submit" variant="contained">삭제</Button>  
        </Box>
      </Box>
    </Box>
  )
}
export default UserDelete